__turbopack_context__.v({
  "container": "NextStepCard-module__5P5voG__container",
  "cta": "NextStepCard-module__5P5voG__cta",
  "desc": "NextStepCard-module__5P5voG__desc",
  "header": "NextStepCard-module__5P5voG__header",
  "icon": "NextStepCard-module__5P5voG__icon",
  "title": "NextStepCard-module__5P5voG__title",
});
